export default __webpack_public_path__ + "assets/wasm/draco_decoder-955f47db575299977fa3535e292f3b3a.wasm";